import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import Home from './screens/Home/Home';
import CutsGlareHowItWorks from './screens/hdpolarized/CutsGlareHowItWorks';
import CutsGlareAxisOfPolarization from './screens/hdpolarized/CutsGlareAxisOfPolarization';
import SingleLayer from './screens/hdpolarized/SingleLayer';
import Switchlock from './screens/switchlock/Switchlock';
import OakleyStealth from './screens/oakleyStealth/OakleyStealth';
import TruBridge from './screens/trueBridge/TruBridge';
import EnhancedVisibility from './screens/prizm/EnhancedVisibility';
import HowItWorks from './screens/prizm/HowItWorks';
import WornByTheBest from './screens/prizm/WornByTheBest';
import SeeForYourself from './screens/prizm/SeeForYourself';
import TrueDigital from './screens/trueDigital/TrueDigital';
import HighDefinitionOpticsClarity from './screens/highDefinitionOptics/HighDefinitionOpticsClarity';
import HighDefinitionOpticsImpact from './screens/highDefinitionOptics/HighDefinitionOpticsImpact';
import VelocityTest from './screens/highDefinitionOptics/VelocityTest/VelocityTest';
import MassTest from './screens/highDefinitionOptics/MassTest/MassTest';
import SportSpecificProgressives from './screens/sportSpecificProgressives/SportSpecificProgressives';

export const ROUTES = {
    HDPOLARIZED_CUTSGLARE: '/hdpolarized/cuts-glare',
    HDPOLARIZED_CUTSGLARE_AXIS: '/hdpolarized/cuts-glare/axis-of-polarization',
    HDPOLARIZED_SINGLELAYER_OAKLEY: '/hdpolarized/single-layer/oakley',
    HDPOLARIZED_SINGLELAYER_COMPETITOR: '/hdpolarized/single-layer/competitor',

    SWITCHLOCK_AIRBRAKESNOW: '/switchlock/airbrake-snow',
    SWITCHLOCK_AIRBRAKEMX: '/switchlock/airbrake-mx',
    SWITCHLOCK_JAWBREAKER: '/switchlock/jawbreaker',

    TRUBRIDGE_SIZING: '/trubridge/sizing',

    PRIZM_ENHANCED: '/prizm/enhanced-visibility',
    PRIZM_HOWITWORKS: '/prizm/how-it-works',
    PRIZM_WORNBYTHEBEST: '/prizm/worn-by-the-best',
    PRIZM_SEEFORYOURSELF: '/prizm/see-for-yourself/baseball',

    HIGH_DEFINITION_OPTICS_CLARITY: '/high-definition-optics/clarity',
    HIGH_DEFINITION_OPTICS_IMPACT: '/high-definition-optics/impact-protection',
    HIGH_DEFINITION_OPTICS_IMPACT_VELOCITY:
        '/high-definition-optics/impact-protection/velocity-test',
    HIGH_DEFINITION_OPTICS_IMPACT_MASS:
        '/high-definition-optics/impact-protection/mass-test',
};

export default function routes(props) {
    return (
        <Switch>
            <Route exact path="/" component={Home} />
            <Route
                exact
                path={ROUTES.PRIZM_ENHANCED}
                component={EnhancedVisibility}
            />
            <Route
                exact
                path={ROUTES.PRIZM_HOWITWORKS}
                component={HowItWorks}
            />
            <Route
                exact
                path={ROUTES.PRIZM_WORNBYTHEBEST}
                component={WornByTheBest}
            />
            <Route
                path="/prizm/see-for-yourself/:type"
                component={SeeForYourself}
            />
            <Route
                exact
                path={ROUTES.HDPOLARIZED_CUTSGLARE}
                component={CutsGlareHowItWorks}
            />
            <Route
                exact
                path={ROUTES.HDPOLARIZED_CUTSGLARE_AXIS}
                component={CutsGlareAxisOfPolarization}
            />
            <Route
                exact
                path={ROUTES.HIGH_DEFINITION_OPTICS_CLARITY}
                component={HighDefinitionOpticsClarity}
            />
            <Route
                exact
                path={ROUTES.HIGH_DEFINITION_OPTICS_IMPACT}
                component={HighDefinitionOpticsImpact}
            />
            <Route
                exact
                path={ROUTES.HIGH_DEFINITION_OPTICS_IMPACT_VELOCITY}
                component={VelocityTest}
            />
            <Route
                exact
                path={ROUTES.HIGH_DEFINITION_OPTICS_IMPACT_MASS}
                component={MassTest}
            />
            <Route
                path="/hdpolarized/single-layer/:type"
                component={SingleLayer}
            />
            <Route exact path="/oakley-true-digital/" component={TrueDigital} />
            <Route
                path="/sport-specific-progressives/:type"
                component={SportSpecificProgressives}
            />
            <Route path="/switchlock/:type" component={Switchlock} />
            <Route path="/oakley-stealth/:type" component={OakleyStealth} />
            <Route path="/trubridge/:type" component={TruBridge} />
            <Redirect to="/" />
        </Switch>
    );
}



// WEBPACK FOOTER //
// ./src/routes.js